import React, { useState, useCallback } from "react";
import { Input, Button } from "antd";
import { SearchOutlined, UpOutlined, DownOutlined } from "@ant-design/icons";
import debounce from "lodash.debounce";
import "./Search.css";

interface SearchInputProps {
  onSearch: (value: string) => void;
  onNavigate?: (direction: "prev" | "next") => void; // callback for up/down
  placeholder: string;
  showPrevNext?: boolean;
  value?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  onSearch,
  onNavigate,
  placeholder,
  showPrevNext,
  value
}) => {
  const [searchTerm, setSearchTerm] = useState(value || "");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((val: string) => onSearch(val), 300),
    [onSearch]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearchTerm(val);
    debouncedSearch(val);
  };

  return (
    <div className="searchWrapper"
    >
    <Input
      placeholder={placeholder}
      value={searchTerm}
      onChange={handleChange}
      allowClear
      prefix={<SearchOutlined className="searchIcon" />}
      suffix={
        (showPrevNext && searchTerm) && (
          <div style={{ display: "flex", gap: 2 }}>
            <Button
              type="text"
              icon={<UpOutlined />}
              onClick={() => onNavigate?.("prev")}
              size="small"
              disabled={!searchTerm}
            />
            <Button
              type="text"
              icon={<DownOutlined />}
              onClick={() => onNavigate?.("next")}
              size="small"
              disabled={!searchTerm}
            />
          </div>
        )
      }
      className="searchInput" 
    />
    </div>
  );
};
